import * as React from 'react';

export const Projects: React.FC = () => {
  return <h1>Projects page</h1>;
};
